export interface ModelTransformer<T, U> {
    transform?: (model: U) => T;

    reverseTransform?: (model: T) => U;
}

export abstract class ModelSetTransformer<T, U>
    implements ModelTransformer<T[], U[]>
{
    protected abstract newTransformer(): ModelTransformer<T, U>;

    transform(model: U[]): T[] {
        const transformer = this.newTransformer();
        const transformed: T[] = [];
        if (model) {
            model.forEach((item) =>
                transformed.push(transformer.transform(item)),
            );
        }
        return transformed;
    }

    reverseTransform(model: T[]): U[] {
        const transformer = this.newTransformer();
        const reverseTransformed: U[] = [];
        model.forEach((item) =>
            reverseTransformed.push(transformer.reverseTransform(item)),
        );
        return reverseTransformed;
    }
}

export interface HttpResponse {
    status: number;
    headers: { get: (...args) => any };
}

export interface APIResponse<T = any> {
    entity: T;
    isSuccess: boolean;
    message: string;
}
